<ng-template
  #labelTemplate
  let-clear="clear"
  let-clearable="clearable"
  let-flagSize="flagSize"
  let-hideName="hideName"
  let-item="item">
  <div
    class="d-flex justify-content-between"
    [title]="item.Name">
    <div class="ng-value-label bn-select__container__dropdown__item__text align-self-start d-flex align-items-center">
      <ng-template *ngTemplateOutlet="flag; context: { $implicit: item.country, flagSize }" />
      @if (!hideName) {
        <span class="ms-1">{{ item.Name }}</span>
      }
      @if (item.indicator) {
        <ng-template *ngTemplateOutlet="indicatorTemplate.indicatorTemplate(); context: { $implicit: item.indicator }" />
      }
    </div>
    <!-- BADGES -->
    @if (item.badges) {
      <div class="align-self-end">
        @for (badge of item.badges; track $index) {
          <bn-web-ui-badge
            containerClass="m-2"
            placement="right"
            [color]="badge?.context"
            [contentClass]="'me-2 z-1 position-relative' + ($index === 0 ? ' ms-2' : '')"
            [size]="badge?.size"
            [tooltip]="badge?.tooltip"
            [type]="badge?.badgeType"
            (click)="clearable && clear(item)">
            @if (badge?.icon) {
              <fa-icon [icon]="badge.icon" />
            }

            {{ badge.text }}
            @if (badge?.rightIcon) {
              <fa-icon [icon]="badge.rightIcon" />
            }
          </bn-web-ui-badge>
        }
      </div>
    }
  </div>
</ng-template>

<!-- FLAG -->
<ng-template
  #flag
  let-country
  let-flagSize="flagSize">
  @if (country) {
    <bn-web-ui-flag
      class="d-inline-block"
      [country]="country"
      [showTooltip]="false"
      [size]="flagSize" />
  }
</ng-template>

<bn-web-ui-indicator-select-template #indicatorTemplate />
